export function MpesaLogo({ className = '', height = 22 }) {
  return (
    <svg viewBox="0 0 120 40" height={height} className={className} role="img" aria-label="M-Pesa">
      <rect x="0" y="0" width="120" height="40" rx="8" fill="#0a8a3a" />
      <text x="60" y="26" textAnchor="middle" fontFamily="Inter, Arial, sans-serif" fontWeight="800" fontSize="16" fill="#ffffff" letterSpacing="0.5">M-PESA</text>
      <circle cx="14" cy="20" r="5" fill="#ec1c24" />
    </svg>
  );
}

export function PaypalLogo({ className = '', height = 22 }) {
  return (
    <svg viewBox="0 0 140 40" height={height} className={className} role="img" aria-label="PayPal">
      <rect x="0" y="0" width="140" height="40" rx="8" fill="#ffffff" stroke="#e5e7eb" />
      <text x="70" y="26" textAnchor="middle" fontFamily="Inter, Arial, sans-serif" fontWeight="800" fontStyle="italic" fontSize="18" letterSpacing="0.3">
        <tspan fill="#003087">Pay</tspan>
        <tspan fill="#009cde">Pal</tspan>
      </text>
    </svg>
  );
}
